import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// ❌ usuwamy bezpośredni import Backend (bo ESM-only)
// import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const fallbackLng = ['pl'];
const availableLanguages = ['pl'];

(async () => {
  // ✅ dynamiczny import ESM backendu
  const { default: Backend } = await import('i18next-http-backend');

  await i18n
    .use(Backend) // backend ładowany dynamicznie
    // .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: 'pl',
      fallbackLng: fallbackLng,
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      detection: {
        checkWhitelist: true,
      },
      whitelist: availableLanguages,
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
        wait: true,
      },
    });
})();

export default i18n;
